import { Timer, WhatsappLogo, Lock, CreditCard } from "@phosphor-icons/react";
import { Link } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export const WHATSAPP_URL = "https://wa.me/905330707431?text=Merhaba%2C%20Bizim%20Cari%20hakk%C4%B1nda%20bilgi%20almak%20istiyorum.";

export const TrialBanner = () => {
  const { user } = useAuth();
  const t = user?.tenant;
  if (!t || t.platform_admin || (t.status !== "trial" && t.status !== "expired")) return null;
  const expired = t.status === "expired";
  return (
    <div className={`no-print flex flex-wrap items-center gap-3 px-4 py-2 text-sm sm:px-6 ${expired ? "bg-red-600 text-white" : "bg-zinc-950 text-white"}`} data-testid={expired ? "trial-expired-banner" : "trial-banner"}>
      {expired ? <Lock weight="fill" /> : <Timer weight="fill" className="text-[#fdba74]" />}
      <span className="font-semibold" data-testid="trial-banner-text">
        {expired ? "Süreniz doldu, bizimle iletişime geçin. Veri girişi kilitlendi." : `Ücretsiz denemenizde ${t.days_left} gün kaldı.`}
      </span>
      {user?.role === "owner" && (
        <Link to="/plan" className="inline-flex items-center gap-1 rounded-full bg-[#fdba74] px-3 py-1 text-xs font-bold text-zinc-950 transition-colors hover:bg-[#fb923c]" data-testid="trial-plan-link">
          <CreditCard weight="fill" size={14} /> Plan seç
        </Link>
      )}
      <a href={WHATSAPP_URL} target="_blank" rel="noreferrer" className={`ml-auto inline-flex items-center gap-1.5 rounded-full px-3 py-1 text-xs font-bold transition-colors ${expired ? "bg-white text-red-700 hover:bg-red-50" : "bg-[#25D366] text-zinc-950 hover:bg-[#1ebe5a]"}`} data-testid="trial-contact-button">
        <WhatsappLogo weight="fill" size={16} /> WhatsApp
      </a>
      <a href="tel:+905330707431" className={`inline-flex items-center rounded-full px-3 py-1 text-xs font-bold ${expired ? "bg-white/20 text-white hover:bg-white/30" : "bg-white/10 text-white hover:bg-white/20"}`} data-testid="trial-phone-button">0533 070 74 31</a>
    </div>
  );
};
